import { useState } from 'react';
import './App.css';
import Splash from './Splash';

const REGISTER_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSfdK1MKlieGcZftMGWV6jyg1HSsP4itL4zS5pqp_2qmaCBjlQ/viewform';
const CONTACT_FORM_URL  = 'https://docs.google.com/forms/d/e/1FAIpQLSeW_iMxf191-QyPFdAHBs33mb1uYB5Uh2vOX9dKpno4xEMp_g/viewform';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showSplash, setShowSplash] = useState(true);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const subjects = [
    { icon: '⚡', name: 'Physics', desc: 'Online tuition for Grade 9–12. Mechanics, Electricity, Optics & more.' },
    { icon: '🧪', name: 'Chemistry', desc: 'Online tuition for Grade 9–12. Organic, Inorganic & Physical Chemistry.' },
    { icon: '🌱', name: 'Biology', desc: 'Online tuition for Grade 9–12. Cell Biology, Genetics, Ecology & more.' },
    { icon: '🔬', name: 'Biochemistry', desc: 'Online tuition for BSc, MSc, Medical & Nursing students.' },
  ];

  const features = [
    { icon: '🎥', title: 'Live Interactive Classes', desc: 'Real-time sessions with experienced tutors via video conferencing.' },
    { icon: '📚', title: 'Recorded Lectures', desc: 'Access recordings anytime — learn at your own pace.' },
    { icon: '📝', title: 'Practice Tests', desc: 'Regular assessments and mock exams to track progress.' },
    { icon: '👨‍🏫', title: 'Expert Tutors', desc: 'Qualified teachers with years of teaching experience.' },
    { icon: '📊', title: 'Progress Reports', desc: 'Detailed monthly reports shared with parents.' },
    { icon: '🕐', title: 'Flexible Timing', desc: 'Morning, evening & weekend slots available.' },
    { icon: '📂', title: 'Study Materials', desc: 'Comprehensive notes, worksheets, and reference materials provided for every topic.' },
  ];

  const grades = [
    'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12',
    'BSc', 'MSc', 'Medical', 'Nursing'
  ];

  return (
    <>
      {showSplash && <Splash onFinish={() => setShowSplash(false)} />}
      <div className="app">
        {/* NAVBAR */}
      <nav className="navbar">
        <div className="nav-inner">
          <div className="logo" onClick={() => scrollTo('hero')}>
            <img src="/cyton-logo.png" alt="Cyton Academy" className="logo-img" />
          </div>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li onClick={() => scrollTo('hero')}>Home</li>
            <li onClick={() => scrollTo('features')}>Why Us</li>
            <li onClick={() => scrollTo('subjects')}>Subjects</li>
            <li onClick={() => scrollTo('testimonials')}>Testimonials</li>
            <li onClick={() => scrollTo('contact')}>Contact</li>
            <li>
              <a href={REGISTER_FORM_URL} target="_blank" rel="noreferrer" className="btn-register-nav">
                Register Now
              </a>
            </li>
          </ul>
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
            <span className={menuOpen ? 'open' : ''} />
            <span className={menuOpen ? 'open' : ''} />
            <span className={menuOpen ? 'open' : ''} />
          </button>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero" id="hero">
        <div className="hero-bg" />
        <div className="hero-content">
          <div className="badge">✨ Online Tuition · Science & Biochemistry</div>
          <h1>
            Learn Smarter with<br />
            <span className="gradient-text">Cyton Academy</span>
          </h1>
          <div className="hero-since">Since 2023</div>
          <p className="hero-sub">
            Expert-led online tuition for Physics, Chemistry & Biology (Grade 9–12) and Biochemistry for BSc, MSc, Medical & Nursing students. Personalised attention, flexible schedules, and proven results — all from the comfort of home.
          </p>
          <div className="hero-ctas">
            <button className="btn-primary" onClick={() => scrollTo('register')}>
              Register for Free →
            </button>
            <button className="btn-outline" onClick={() => scrollTo('features')}>
              Learn More
            </button>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-num">8</span>
              <span className="stat-label">Programmes</span>
            </div>
            <div className="stat-sep" />
            <div className="stat">
              <span className="stat-num">4</span>
              <span className="stat-label">Subjects</span>
            </div>
            <div className="stat-sep" />
            <div className="stat">
              <span className="stat-num">98%</span>
              <span className="stat-label">Satisfaction</span>
            </div>
          </div>
        </div>
        <div className="hero-illustration">
          <div className="illus-circle" />
          <div className="illus-card card1">
            <span className="card-icon">⚡</span>
            <span className="card-subj">Physics</span>
            <span className="card-grade">Grade 9 &amp; 10</span>
          </div>
          <div className="illus-card card2">
            <span className="card-icon">🧪</span>
            <span className="card-subj">Chemistry</span>
            <span className="card-grade">Grade 9–12</span>
          </div>
          <div className="illus-card card3">
            <span className="card-icon">🌱</span>
            <span className="card-subj">Biology</span>
            <span className="card-grade">Grade 9–12</span>
          </div>
          <div className="illus-card card4">
            <span className="card-icon">🔬</span>
            <span className="card-subj">Biochemistry</span>
            <span className="card-grade">BSc · MSc · Medical · Nursing</span>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="features-section" id="features">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">Why Cyton Academy?</div>
            <h2>Everything you need to excel</h2>
            <p>Our online platform combines technology with quality teaching for the best learning experience.</p>
          </div>
          <div className="features-grid">
            {features.map((f, i) => (
              <div className="feature-card" key={i}>
                <div className="feature-icon">{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* VIDEO */}
      <section className="video-section">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">See It In Action</div>
            <h2>Watch how Cyton Academy works</h2>
            <p>Get a feel for our live classes, tutors, and the learning experience we offer.</p>
          </div>
          <div className="videos-grid">
            <div className="video-wrapper">
              <iframe
                src="https://www.youtube.com/embed/cLO_SeellUI"
                title="Cyton Academy — How It Works"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="video-wrapper">
              <iframe
                src="https://www.youtube.com/embed/sY3AeJt2ytI"
                title="Cyton Academy — Class Preview"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </section>

      {/* SUBJECTS */}
      <section className="subjects-section" id="subjects">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">Subjects</div>
            <h2>Online tuition for Science & Biochemistry</h2>
            <p>We offer online tuition for Physics, Chemistry & Biology (Grade 9–12) and Biochemistry for higher education students.</p>
          </div>
          <div className="subjects-grid">
            {subjects.map((s, i) => (
              <div className="subject-card" key={i}>
                <div className="subject-icon">{s.icon}</div>
                <h3>{s.name}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* GRADES BANNER */}
      <section className="grades-section">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">Who We Teach</div>
            <h2>Grade 9–12 and Higher Education</h2>
          </div>
          <div className="grades-grid">
            {grades.map((g, i) => (
              <div className="grade-chip" key={i}>{g}</div>
            ))}
          </div>
        </div>
      </section>

      {/* REGISTRATION */}
      <section className="register-section" id="register">
        <div className="container">
          <div className="register-wrap">
            <div className="register-left">
              <div className="section-tag">Online Registration</div>
              <h2>Enrol Your Child Today</h2>
              <p>Fill in the form and our team will get back to you within 24 hours to confirm your slot and share next steps.</p>
              <ul className="register-perks">
                <li>✅ Free first demo class</li>
                <li>✅ No registration fee</li>
                <li>✅ Flexible batch timings</li>
                <li>✅ Dedicated tutor assigned</li>
              </ul>
            </div>
            <div className="register-right">
              <div className="form-link-card">
                <div className="form-link-icon">📋</div>
                <h3>Registration Form</h3>
                <p>Click the button below to open the registration form. It takes less than 2 minutes to complete.</p>
                <a
                  href={REGISTER_FORM_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-primary full-width form-link-btn"
                >
                  Open Registration Form →
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="contact-section" id="contact">
        <div className="container">
          <div className="section-header">
            <div className="section-tag">Contact Us</div>
            <h2>We're here to help</h2>
            <p>Reach out to us for any enquiries and we'll get back to you shortly.</p>
          </div>
          <div className="contact-wrap">
            <div className="contact-info">
              <a href="mailto:cytonacademy@gmail.com" className="contact-item contact-link">
                <div className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"/></svg>
                </div>
                <div>
                  <strong>Email</strong>
                  <p>cytonacademy@gmail.com</p>
                </div>
              </a>
              <a href="tel:+919074165316" className="contact-item contact-link">
                <div className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
                </div>
                <div>
                  <strong>Phone</strong>
                  <p>+91 9074165316</p>
                </div>
              </a>
              <a href="https://wa.me/919074165316" target="_blank" rel="noreferrer" className="contact-item contact-link">
                <div className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>
                </div>
                <div>
                  <strong>WhatsApp</strong>
                  <p>+91 9074165316</p>
                </div>
              </a>
              <div className="social-links">
                <a href="https://www.youtube.com/@CytonAcademy" target="_blank" rel="noreferrer" className="social-icon-btn youtube" aria-label="YouTube">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                  <span>YouTube</span>
                </a>
                <a href="https://www.facebook.com/profile.php?id=61573958428625" target="_blank" rel="noreferrer" className="social-icon-btn facebook" aria-label="Facebook">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                  <span>Facebook</span>
                </a>
                <a href="https://www.instagram.com/cyton_academy/" target="_blank" rel="noreferrer" className="social-icon-btn instagram" aria-label="Instagram">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>
                  <span>Instagram</span>
                </a>
              </div>
            </div>
            <div className="contact-form-wrap">
              <div className="form-link-card">
                <div className="form-link-icon">✉️</div>
                <h3>Send us a Message</h3>
                <p>Have a question or need more information? Fill out our contact form and we'll get back to you within 24 hours.</p>
                <a
                  href={CONTACT_FORM_URL}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-primary full-width form-link-btn"
                >
                  Open Contact Form →
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="testimonials" id="testimonials">
        <div className="container">
          <h2>What Our Students Say</h2>
          <p className="section-subtitle">Real WhatsApp screenshot feedback from students learning with Cyton Academy</p>
          <div className="testimonials-grid">
            <div className="testimonial-card screenshot">
              <div className="testimonial-image-wrap">
                <img src="/testimonial-1.png" alt="WhatsApp screenshot feedback 1" className="testimonial-image" />
              </div>
              <div className="testimonial-content">
                <div className="testimonial-rating">★★★★★</div>
                <div className="testimonial-details">
                  <span className="testimonial-name">Parent of Amritdev</span>
                  <span className="testimonial-meta">IGCSE Singapore, Grade 12</span>
                </div>
              </div>
            </div>
            <div className="testimonial-card screenshot">
              <div className="testimonial-image-wrap">
                <img src="/testimonial-2.png" alt="WhatsApp screenshot feedback 2" className="testimonial-image" />
              </div>
              <div className="testimonial-content">
                <div className="testimonial-rating">★★★★★</div>
                <div className="testimonial-details">
                  <span className="testimonial-name">Anjana</span>
                  <span className="testimonial-meta">CBSE Dubai, Grade 10</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="container">
          <div className="footer-top">
            <div className="footer-brand">
              <div className="logo">
                <img src="/cyton-logo.png" alt="Cyton Academy" className="logo-img logo-img-footer" />
              </div>
              <p>Expert-led online tuition for Physics, Chemistry & Biology (Grade 9–12) and Biochemistry for BSc, MSc, Medical & Nursing students.</p>
            </div>
            <div className="footer-links">
              <h4>Quick Links</h4>
              <ul>
                <li onClick={() => scrollTo('hero')}>Home</li>
                <li onClick={() => scrollTo('features')}>Why Us</li>
                <li onClick={() => scrollTo('subjects')}>Subjects</li>
                <li onClick={() => scrollTo('testimonials')}>Testimonials</li>
                <li onClick={() => scrollTo('register')}>Register</li>
                <li onClick={() => scrollTo('contact')}>Contact</li>
              </ul>
            </div>
            <div className="footer-links">
              <h4>Subjects</h4>
              <ul>
                <li>Physics</li>
                <li>Chemistry</li>
                <li>Biology</li>
                <li>Biochemistry</li>
              </ul>
            </div>
            <div className="footer-links">
              <h4>Programmes</h4>
              <ul>
                <li>Grade 9 – 12</li>
                <li>BSc</li>
                <li>MSc</li>
                <li>Medical</li>
                <li>Nursing</li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>© 2025 Cyton Academy. All rights reserved.</p>
            <p>Launched since 2023 • Built with ❤️ for students everywhere.</p>
          </div>
        </div>
      </footer>
      </div>
    </>
  );
}

export default App;
